// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file branch/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { StockPointType } from "../auth/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.StockPoint
 */
export class StockPoint extends Message<StockPoint> {
  /**
   * Unique identifier for the stock point
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Name of the stock point
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * Total number of users with access to this stock point
   *
   * @generated from field: int32 total_users_with_access = 3;
   */
  totalUsersWithAccess = 0;

  /**
   * Name of the manager responsible for this stock point
   *
   * @generated from field: string manager_name = 4;
   */
  managerName = "";

  /**
   * Timestamp when the stock point was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * Start time of the current shift
   *
   * @generated from field: string shift_start_time = 6;
   */
  shiftStartTime = "";

  /**
   * Total number of inventory items in this stock point
   *
   * @generated from field: int32 total_inventory_items = 7;
   */
  totalInventoryItems = 0;

  /**
   * Type of the stock point (e.g., pharmacy, warehouse, etc.)
   *
   * @generated from field: com.neulink.pharmacy.StockPointType stock_point_type = 8;
   */
  stockPointType = StockPointType.UNKNOWN;

  constructor(data?: PartialMessage<StockPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_users_with_access", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "manager_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "shift_start_time", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "total_inventory_items", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "stock_point_type", kind: "enum", T: proto3.getEnumType(StockPointType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockPoint {
    return new StockPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockPoint {
    return new StockPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockPoint {
    return new StockPoint().fromJsonString(jsonString, options);
  }

  static equals(a: StockPoint | PlainMessage<StockPoint> | undefined, b: StockPoint | PlainMessage<StockPoint> | undefined): boolean {
    return proto3.util.equals(StockPoint, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.StockPointActivity
 */
export class StockPointActivity extends Message<StockPointActivity> {
  /**
   * Unique identifier for the stock point activity
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Timestamp of the activity
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * Value of the activity (e.g., stock added, stock removed)
   *
   * @generated from field: float activity_value = 3;
   */
  activityValue = 0;

  constructor(data?: PartialMessage<StockPointActivity>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.StockPointActivity";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "activity_value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StockPointActivity {
    return new StockPointActivity().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StockPointActivity {
    return new StockPointActivity().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StockPointActivity {
    return new StockPointActivity().fromJsonString(jsonString, options);
  }

  static equals(a: StockPointActivity | PlainMessage<StockPointActivity> | undefined, b: StockPointActivity | PlainMessage<StockPointActivity> | undefined): boolean {
    return proto3.util.equals(StockPointActivity, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.Branch
 */
export class Branch extends Message<Branch> {
  /**
   * @generated from field: string pharmacy_code = 1;
   */
  pharmacyCode = "";

  /**
   * @generated from field: string pharmacy_name = 2;
   */
  pharmacyName = "";

  /**
   * @generated from field: string branch_size = 3;
   */
  branchSize = "";

  /**
   * @generated from field: repeated com.neulink.pharmacy.StockPoint stock_points = 4;
   */
  stockPoints: StockPoint[] = [];

  constructor(data?: PartialMessage<Branch>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.Branch";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pharmacy_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pharmacy_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "branch_size", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "stock_points", kind: "message", T: StockPoint, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Branch {
    return new Branch().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Branch {
    return new Branch().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Branch {
    return new Branch().fromJsonString(jsonString, options);
  }

  static equals(a: Branch | PlainMessage<Branch> | undefined, b: Branch | PlainMessage<Branch> | undefined): boolean {
    return proto3.util.equals(Branch, a, b);
  }
}

